module.exports = __webpack_public_path__ + "img/assembly of .4415f0ea.jpg";